import apiClient from "./client";
import {
  AdminStats,
  AdminUser,
  AdminUserDetail,
  AdminUsersResponse,
  AdminJobsResponse,
  AdminUserFilters,
  AdminJobFilters,
} from "../types";

// Get admin stats
export const getAdminStats = async (): Promise<AdminStats> => {
  const response = await apiClient.get<AdminStats>("/admin/stats");
  return response.data;
};

// Get admin users with filters
export const getAdminUsers = async (
  filters?: AdminUserFilters
): Promise<AdminUsersResponse> => {
  const params = new URLSearchParams();

  if (filters?.role) params.append("role", filters.role);
  if (filters?.auth_provider)
    params.append("auth_provider", filters.auth_provider);
  if (filters?.is_active !== undefined)
    params.append("is_active", String(filters.is_active));
  if (filters?.page) params.append("page", String(filters.page));
  if (filters?.limit) params.append("limit", String(filters.limit));

  const response = await apiClient.get<AdminUsersResponse>(
    `/admin/users?${params.toString()}`
  );
  return response.data;
};

// Get single user details (admin)
export const getAdminUser = async (
  userId: string
): Promise<AdminUserDetail> => {
  const response = await apiClient.get<AdminUserDetail>(
    `/admin/users/${userId}`
  );
  return response.data;
};

// Update user role
export const updateUserRole = async (
  userId: string,
  role: "user" | "admin"
): Promise<AdminUser> => {
  const response = await apiClient.patch<AdminUser>(
    `/admin/users/${userId}/role`,
    { role }
  );
  return response.data;
};

// Update user status
export const updateUserStatus = async (
  userId: string,
  isActive: boolean
): Promise<AdminUser> => {
  const response = await apiClient.patch<AdminUser>(
    `/admin/users/${userId}/status`,
    { is_active: isActive }
  );
  return response.data;
};

// Delete user (soft delete)
export const deleteUser = async (userId: string): Promise<void> => {
  await apiClient.delete(`/admin/users/${userId}`);
};

// Get admin jobs with filters
export const getAdminJobs = async (
  filters?: AdminJobFilters
): Promise<AdminJobsResponse> => {
  const params = new URLSearchParams();

  if (filters?.status) params.append("status", filters.status);
  if (filters?.job_type) params.append("job_type", filters.job_type);
  if (filters?.user_id) params.append("user_id", filters.user_id);
  if (filters?.page) params.append("page", String(filters.page));
  if (filters?.limit) params.append("limit", String(filters.limit));

  const response = await apiClient.get<AdminJobsResponse>(
    `/admin/jobs?${params.toString()}`
  );
  return response.data;
};
